var _excluded = ["bounds", "boundsOptions", "center", "children", "className", "id", "placeholder", "style", "whenReady", "zoom"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { LeafletProvider, createLeafletContext } from '@react-leaflet/core';
import { Map as LeafletMap } from 'leaflet';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
function MapContainerComponent(_ref, forwardedRef) {
  var bounds = _ref.bounds,
    boundsOptions = _ref.boundsOptions,
    center = _ref.center,
    children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    placeholder = _ref.placeholder,
    style = _ref.style,
    whenReady = _ref.whenReady,
    zoom = _ref.zoom,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({
      className: className,
      id: id,
      style: style
    }),
    _useState2 = _slicedToArray(_useState, 1),
    props = _useState2[0];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    context = _useState4[0],
    setContext = _useState4[1];
  useImperativeHandle(forwardedRef, function () {
    var _context$map;
    return (_context$map = context === null || context === void 0 ? void 0 : context.map) !== null && _context$map !== void 0 ? _context$map : null;
  }, [context]);
  var mapRef = useCallback(function (node) {
    if (node !== null && context === null) {
      var map = new LeafletMap(node, options);
      if (center != null && zoom != null) {
        map.setView(center, zoom);
      } else if (bounds != null) {
        map.fitBounds(bounds, boundsOptions);
      }
      if (whenReady != null) {
        map.whenReady(whenReady);
      }
      setContext(createLeafletContext(map));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    return function () {
      context === null || context === void 0 ? void 0 : context.map.remove();
    };
  }, [context]);
  var contents = context ? /*#__PURE__*/React.createElement(LeafletProvider, {
    value: context
  }, children) : placeholder !== null && placeholder !== void 0 ? placeholder : null;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: mapRef
  }), contents);
}
export var MapContainer = /*#__PURE__*/forwardRef(MapContainerComponent);